/*****************************************************
AB - sept-q1-incentivos-pdp
Incentivos escalonados en la PDP (variante B).

Resuelve que mensaje se muestra arriba del boton de Agregar segun el valor
real del carrito y lo mantiene sincronizado con cualquier cambio, venga del
formulario del producto, del drawer de UpCart o de otra pestana.

Los regalos los sigue agregando UpCart: este archivo solo comunica progreso,
nunca escribe en el carrito.
*****************************************************/
(function () {
  'use strict';

  // El theme reinyecta los <script> del buy box cuando reemplaza el
  // product-info al cambiar de variante. Sin esta guarda la segunda pasada
  // dejaria window.pdpIncentives apuntando a un closure huerfano, con su
  // propio estado vacio.
  if (window.__pdpIncentivesLoaded) return;
  window.__pdpIncentivesLoaded = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  // Botones de agregar al carrito del theme, de UpCart y de cualquier form que
  // apunte a /cart/add.
  var ADD_TO_CART_SELECTOR = [
    '[name="add"]',
    '.product-form__submit',
    '[data-add-to-cart]',
    '[class*="upcart-add"]',
    'form[action*="/cart/add"] [type="submit"]'
  ].join(',');

  // El carrito tarda en reflejar el add: se relee escalonado hasta que cambie.
  var ADD_TO_CART_RETRIES = [400, 1200, 2400];

  var LATCH_CLASS = 'pdp-incentives-on';

  // Convert puede inyectar su CSS un instante despues de que corra este
  // script, asi que el latch se reintenta un par de veces al arrancar.
  var LATCH_RETRIES = [0, 300, 1000];

  // El backend tarda un instante en reflejar el cambio; mismo margen que ya
  // usa el theme en cart-updater.
  var REFRESH_DELAY = 450;

  /* ======================================================================
     Formato de moneda
     ====================================================================== */

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function withDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    thousands = thousands || ',';
    decimal = decimal || '.';

    var parts = (cents / 100).toFixed(precision).split('.');
    var units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

    return parts[1] ? units + decimal + parts[1] : units;
  }

  function formatMoney(cents, format, hideTrailingZeros) {
    var formatString = format || '${{amount}}';
    var match = formatString.match(PLACEHOLDER);
    if (!match) return formatString;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    if (hideTrailingZeros) value = value.replace(/[.,]00$/, '');

    return formatString.replace(PLACEHOLDER, value);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function isTrue(value) {
    return value === 'true' || value === '1';
  }

  /* ======================================================================
     Trigger de Convert
     ====================================================================== */

  // El experimento se activa por location manual: solo entran los visitantes
  // que estan en una PDP y ya traen algo en el carrito, que son los unicos a
  // los que la variante B les cambia algo. Se dispara para las dos variantes,
  // porque es lo que le dice a Convert a quien repartir.
  //
  // Se lleva por URL y no una sola vez por pagina: al cambiar de variante el
  // theme reescribe la URL con ?variant=..., Convert lo lee como navegacion y
  // desactiva la variacion si la location no vuelve a dispararse.
  var firedLocations = {};

  function currentUrlKey() {
    return window.location.pathname + window.location.search;
  }

  function triggerLocation(locationId) {
    if (!locationId) return false;

    var key = locationId + '@' + currentUrlKey();
    if (firedLocations[key]) return false;
    firedLocations[key] = true;

    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: 'triggerLocation',
      params: { locationId: locationId }
    });

    return true;
  }

  /* ======================================================================
     Estado del carrito compartido por todas las instancias
     ====================================================================== */

  var listeners = [];
  var timer = null;
  var inFlight = false;
  var queued = false;

  // Ultimo carrito leido en esta pagina. El theme reemplaza el buy box entero
  // al cambiar de variante, asi que el componente se vuelve a crear: con esto
  // se repinta al instante en vez de quedarse en blanco esperando la red.
  var lastCart = null;

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
    return root + '.js';
  }

  function notify(cart) {
    lastCart = cart;

    listeners.forEach(function (listener) {
      try {
        listener(cart);
      } catch (e) {}
    });
  }

  function fetchCart() {
    // Si ya hay una lectura en curso se encola otra en vez de descartarla:
    // varios cambios seguidos del carrito no pueden perder el ultimo estado.
    if (inFlight) {
      queued = true;
      return;
    }

    inFlight = true;

    window
      .fetch(cartUrl(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        inFlight = false;
        notify(cart);

        if (queued) {
          queued = false;
          fetchCart();
        }
      })
      .catch(function () {
        inFlight = false;
        queued = false;
      });
  }

  function scheduleRefresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(fetchCart, typeof delay === 'number' ? delay : REFRESH_DELAY);
  }

  function isCartMutation(url) {
    return typeof url === 'string' && CART_MUTATION.test(url);
  }

  // Latch de la variante B. Convert retira el CSS de la variacion cuando lee
  // el cambio de URL del selector de variantes; una vez que se comprobo que el
  // componente estaba visible, el theme lo sostiene solo.
  //
  // La variante A nunca entra aqui: para ella el componente nunca esta visible.
  function latchIfRevealed(el) {
    var root = document.documentElement;
    if (root.classList.contains(LATCH_CLASS)) return;
    if (el.getAttribute('data-visible') !== 'true') return;

    var styles = window.getComputedStyle(el);

    // El centinela distingue "oculto" de "el CSS del componente aun no cargo".
    // Sin el, un custom element sin estilos (display:inline) pasaria por
    // visible y se marcaria la variante A por error.
    if (styles.getPropertyValue('--pdp-incentives-ready').trim() !== '1') return;
    if (styles.display === 'none') return;

    root.classList.add(LATCH_CLASS);
  }

  // Repinta todas las instancias con el ultimo carrito conocido. Se usa cuando
  // cambia la URL (cambio de variante): no hace falta releer el carrito, pero
  // si volver a evaluar el trigger, que se lleva por URL.
  function reapply() {
    if (lastCart) notify(lastCart);
  }

  // Los hooks se instalan una sola vez aunque haya varias instancias del
  // componente en la pagina.
  function installHooks() {
    if (window.__pdpIncentivesHooked) return;
    window.__pdpIncentivesHooked = true;

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function () {
        var input = arguments[0];
        var requested = typeof input === 'string' ? input : (input && input.url) || '';

        return originalFetch.apply(this, arguments).then(function (response) {
          if (isCartMutation(requested) || isCartMutation(response && response.url)) {
            scheduleRefresh();
          }
          return response;
        });
      };
    }

    var OriginalXHR = window.XMLHttpRequest;
    if (typeof OriginalXHR === 'function') {
      var PatchedXHR = function () {
        var xhr = new OriginalXHR();
        var open = xhr.open;

        xhr.open = function () {
          this.__pdpIncentivesUrl = arguments[1];
          return open.apply(this, arguments);
        };

        xhr.addEventListener('load', function () {
          if (isCartMutation(this.__pdpIncentivesUrl)) scheduleRefresh();
        });

        return xhr;
      };
      PatchedXHR.prototype = OriginalXHR.prototype;
      window.XMLHttpRequest = PatchedXHR;
    }

    // UpCart re-renderiza el drawer en cada cambio y expone estos hooks
    // globales. Se encadenan para no pisar lo que ya haya registrado otro
    // script (la prueba de cart-optimization usa los mismos).
    ['upcartOnCartLoaded', 'upcartOnCartUpdated', 'upcartOnCartOpened'].forEach(function (hook) {
      var previous = window[hook];
      window[hook] = function () {
        if (typeof previous === 'function') {
          try {
            previous.apply(this, arguments);
          } catch (e) {}
        }
        scheduleRefresh(0);
      };
    });

    // Add to cart desde el formulario del propio theme, y cambio de variante.
    // El cambio de variante importa porque reescribe la URL: hay que volver a
    // disparar la location para que Convert no desactive la variacion.
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          scheduleRefresh(0);
        });

        subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
          reapply();
        });
      }
    } catch (e) {}

    // Red de seguridad por si el cambio de URL no viene del pubsub del theme.
    window.addEventListener('popstate', reapply);

    // Red de seguridad para el add to cart. Los hooks de arriba solo ven las
    // peticiones que pasan por el window.fetch / XHR de esta pagina, y UpCart
    // puede haber guardado su propia referencia antes de que se envolvieran.
    // Un clic en cualquier boton de agregar dispara unas relecturas escalonadas
    // del carrito, asi que da igual por donde se haga el add.
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        if (!target.closest(ADD_TO_CART_SELECTOR)) return;

        // Se deja de reintentar en cuanto el carrito refleja el alta, asi que
        // en el caso normal esto es una sola lectura.
        var before = lastCart ? lastCart.item_count : -1;

        ADD_TO_CART_RETRIES.forEach(function (delay) {
          setTimeout(function () {
            if (lastCart && lastCart.item_count !== before) return;
            fetchCart();
          }, delay);
        });
      },
      true
    );

    // Volver a la PDP desde el back/forward cache, o desde otra pestana en la
    // que se modifico el carrito.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) scheduleRefresh(0);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleRefresh(0);
    });
  }

  /* ======================================================================
     Componente
     ====================================================================== */

  class PdpIncentives extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
      this.hideTrailingZeros = isTrue(this.getAttribute('data-hide-trailing-zeros'));
      this.calcBase = this.getAttribute('data-calc-base') || 'paid_items';
      this.triggerLocation = this.getAttribute('data-trigger-location') || '';
      this.hideWhenEmpty = isTrue(this.getAttribute('data-hide-when-empty'));
      this.showPending = isTrue(this.getAttribute('data-show-pending'));
      this.showUnlocked = isTrue(this.getAttribute('data-show-unlocked'));

      this.tiers = Array.from(this.querySelectorAll('.pdp-incentives__tier'))
        .map(function (node) {
          return { node: node, goal: parseInt(node.getAttribute('data-goal'), 10) || 0 };
        })
        .filter(function (tier) {
          return tier.goal > 0;
        })
        .sort(function (a, b) {
          return a.goal - b.goal;
        });

      this.finalNode = this.querySelector('.pdp-incentives__tier[data-final]');

      if (!this.tiers.length && !this.finalNode) return;

      // El componente siempre resuelve su estado; quien decide si se ve es el
      // CSS. Asi la prueba se enciende con una sola regla desde Convert, sin
      // depender de que su JS corra ni de en que orden lo haga.
      this.activate();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    activate() {
      if (this.active) return;
      this.active = true;

      var handler = (cart) => {
        this.update(this.baseFrom(cart), (cart && cart.item_count) || 0);
      };

      listeners.push(handler);
      this.unsubscribe = function () {
        listeners = listeners.filter(function (fn) {
          return fn !== handler;
        });
      };

      // Esta instancia puede ser un reemplazo del buy box tras un cambio de
      // variante. Si ya se leyo el carrito en esta pagina se pinta de una vez,
      // sin hueco visible.
      if (lastCart) handler(lastCart);

      LATCH_RETRIES.forEach((delay) => {
        setTimeout(() => latchIfRevealed(this), delay);
      });

      installHooks();

      // El componente no muestra nada hasta que /cart.js confirma el estado
      // real: el HTML de la PDP puede venir del cache de Shopify y traer un
      // carrito que no es el de esta sesion.
      scheduleRefresh(0);
    }

    baseFrom(cart) {
      if (!cart) return 0;
      if (this.calcBase === 'cart_total') return cart.total_price || 0;

      return (cart.items || []).reduce(function (total, item) {
        var line = item.final_line_price;
        if (typeof line !== 'number') line = (item.final_price || 0) * (item.quantity || 0);

        // Las lineas en $0 son los regalos que ya otorgo el carrito: no
        // cuentan como avance hacia el siguiente umbral.
        return line > 0 ? total + line : total;
      }, 0);
    }

    update(base, itemCount) {
      var pendingTier = null;
      var unlockedTier = null;

      this.tiers.forEach(function (tier) {
        if (tier.goal <= base) {
          unlockedTier = tier;
        } else if (!pendingTier) {
          pendingTier = tier;
        }
      });

      // Se calcula antes de aplicar los toggles: el mensaje final depende de
      // que no quede nada por desbloquear, no de que se este mostrando.
      var allUnlocked = !pendingTier;

      if (!this.showPending) pendingTier = null;
      if (!this.showUnlocked) unlockedTier = null;

      var shown = 0;

      this.tiers.forEach((tier) => {
        var state = 'none';

        if (tier === pendingTier && this.hasRow(tier.node, 'pending')) {
          state = 'pending';
          this.renderRow(tier.node, 'pending', tier.goal - base);
        } else if (tier === unlockedTier && this.hasRow(tier.node, 'unlocked')) {
          state = 'unlocked';
          this.renderRow(tier.node, 'unlocked', tier.goal);
        }

        if (state !== 'none') shown += 1;
        if (tier.node.getAttribute('data-show') !== state) {
          tier.node.setAttribute('data-show', state);
        }
      });

      if (this.finalNode) {
        var finalState = allUnlocked ? 'final' : 'none';

        if (finalState === 'final') {
          this.renderRow(this.finalNode, 'final', 0);
          shown += 1;
        }

        if (this.finalNode.getAttribute('data-show') !== finalState) {
          this.finalNode.setAttribute('data-show', finalState);
        }
      }

      // La condicion del experimento es solo "PDP con carrito no vacio": no
      // depende de que haya un incentivo que mostrar, para que la variante A
      // y la B entren exactamente con el mismo criterio.
      if (itemCount > 0 && triggerLocation(this.triggerLocation)) {
        this.setAttribute('data-trigger-fired', 'true');
      }

      var visible = shown > 0 && (itemCount > 0 || !this.hideWhenEmpty);

      this.setAttribute('data-visible', visible ? 'true' : 'false');
      this.setAttribute('data-cart-base', base);
      this.setAttribute('data-cart-item-count', itemCount);

      latchIfRevealed(this);
    }

    hasRow(node, type) {
      return !!node.querySelector('.pdp-incentives__row--' + type);
    }

    // El copy lo escribe el merchant en el theme editor con las banderas
    // {monto} y {producto}; aqui se resuelven las dos. El HTML del richtext
    // viene sanitizado por Shopify, lo unico que se escapa es lo que se
    // inyecta: el monto formateado y el nombre del regalo.
    renderRow(node, type, amountCents) {
      var text = node.querySelector('.pdp-incentives__row--' + type + ' .pdp-incentives__text');
      if (!text) return;

      var money = formatMoney(Math.max(amountCents, 0), this.moneyFormat, this.hideTrailingZeros);
      var giftName = node.getAttribute('data-gift-name') || '';

      var html = (text.getAttribute('data-template') || '')
        .split('{monto}')
        .join('<span class="pdp-incentives__amount">' + escapeHtml(money) + '</span>')
        .split('{producto}')
        .join(escapeHtml(giftName));

      if (text.innerHTML !== html) text.innerHTML = html;
    }
  }

  if (!customElements.get('pdp-incentives')) {
    customElements.define('pdp-incentives', PdpIncentives);
  }

  // Activacion manual para QA: inyecta la misma regla que Convert pega en el
  // CSS de la variacion, para poder ver la variante B sin tener que crear el
  // experimento.
  var QA_STYLE_ID = 'pdp-incentives-activation';

  function injectActivationStyle() {
    if (document.getElementById(QA_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = QA_STYLE_ID;
    style.textContent =
      'html body .pdp-incentives[data-visible="true"]{display:block !important}';
    document.head.appendChild(style);
  }

  window.pdpIncentives = {
    activate: function () {
      injectActivationStyle();
    },
    refresh: function () {
      scheduleRefresh(0);
    },
    // Estado resuelto del componente, para QA.
    state: function () {
      return Array.prototype.map.call(
        document.querySelectorAll('pdp-incentives'),
        function (el) {
          return {
            visible: el.getAttribute('data-visible'),
            cartBase: el.getAttribute('data-cart-base'),
            itemCount: el.getAttribute('data-cart-item-count'),
            triggerLocation: el.getAttribute('data-trigger-location'),
            triggerFired: el.getAttribute('data-trigger-fired') === 'true',
            latched: document.documentElement.classList.contains(LATCH_CLASS),
            display: window.getComputedStyle(el).display,
            finalShow: (function (node) {
              return node ? node.getAttribute('data-show') : null;
            })(el.querySelector('.pdp-incentives__tier[data-final]')),
            tiers: Array.prototype.map.call(
              el.querySelectorAll('.pdp-incentives__tier'),
              function (tier) {
                return {
                  goal: tier.getAttribute('data-goal'),
                  show: tier.getAttribute('data-show'),
                  gift: tier.getAttribute('data-gift-name')
                };
              }
            )
          };
        }
      );
    },
    formatMoney: formatMoney
  };
})();
